/* eslint-disable react-hooks/exhaustive-deps */
import React, { useRef, useEffect } from 'react'
import './index.css'
import { isAndroid } from '../../utils'

interface InputProps {
    value?: string
    placeholder?: string
    className?: string
    type?: 'text' | 'password' | 'number'
    style?: React.CSSProperties
    onChange?: (value: string) => void
    suffix?: React.ReactNode
    autoCumplete?: string
    multiple?: boolean
    autoGrow?: boolean
    maxLength?: number
    after?: React.ReactNode
    before?: React.ReactNode
    prefix?: React.ReactNode
    onBlur?: () => void
    disabled?: boolean
    onFocus?: () => void
    autoFocus?: boolean
    autoResize?: boolean
    autocomplete?: string
}
const Input: React.FC<InputProps> = (props) => {
    const {
        value = '',
        style,
        placeholder,
        suffix,
        type,
        className,
        multiple = false,
        maxLength,
        onChange = (value: string) => undefined,
        prefix,
        after,
        before,
        disabled,
        autoFocus,
        autoResize = true,
        onBlur = () => undefined,
        onFocus = () => undefined,
    } = props
    const inputRef = useRef<any | null>(null)
    useEffect(() => {
        if (inputRef.current && autoFocus) {
            let timer = setTimeout(() => {
                inputRef.current.focus()
                clearTimeout(timer)
            }, 500)
        }
    }, [autoFocus])
    const handleAutoSize = () => {
        if (autoResize && inputRef.current) {
            const scrollHeight = inputRef.current.scrollHeight
            let timer = setTimeout(() => {
                if (!inputRef.current) {
                    clearTimeout(timer)
                    return
                }
                inputRef.current.style.cssText = 'height: auto; padding: 0'
                if (scrollHeight < 40) {
                    inputRef.current.style.cssText = `height: 4rem;`
                } else {
                    inputRef.current.style.cssText = `height: ${scrollHeight}px;`
                }
                clearTimeout(timer)
            }, 0)
        }
    }
    useEffect(() => {
        let timer = setTimeout(() => {
            handleAutoSize()
            clearTimeout(timer)
        }, 50)
    }, [])
    return (
        <div
            className={`wl-input-item ${className} ${
                suffix ? 'suffix-inner' : ''
            } ${prefix ? 'prefix-inner' : ''}`}
        >
            {before}
            {prefix && <div className='prefix'>{prefix}</div>}
            {!multiple && (
                <input
                    className={`ion-input ${disabled ? 'disabled' : ''}`}
                    type={type}
                    value={value}
                    disabled={disabled}
                    name='wl'
                    style={style}
                    maxLength={maxLength || 500}
                    ref={inputRef}
                    onBlur={(e) => {
                        // window.scroll(0, 0)
                        onBlur()
                        var scrollHeight =
                            document.documentElement.scrollTop ||
                            document.body.scrollTop ||
                            0
                        // let target = e.target
                        let timer = setTimeout(() => {
                            window.scrollTo(0, Math.max(scrollHeight - 1, 0))
                            clearTimeout(timer)
                        })
                    }}
                    autoFocus={autoFocus}
                    onFocus={(e) => {
                        onFocus()
                        if (isAndroid()) {
                            const target = e.target
                            let timer = setTimeout(() => {
                                target.scrollIntoView()
                                clearTimeout(timer)
                            })
                        }
                    }}
                    onChange={(e) => {
                        // e.target.scrollIntoView(true)
                        onChange(e.target.value as string)
                    }}
                    placeholder={placeholder}
                />
            )}
            {multiple && (
                <textarea
                    className={`ion-textarea  ${disabled ? 'disabled' : ''}`}
                    value={value}
                    style={style}
                    rows={1}
                    disabled={disabled}
                    ref={inputRef}
                    maxLength={maxLength || 500}
                    onKeyDown={handleAutoSize}
                    onBlur={(e) => {
                        // window.scroll(0, 0)
                        onBlur()
                        var scrollHeight =
                            document.documentElement.scrollTop ||
                            document.body.scrollTop ||
                            0
                        // let target = e.target
                        let timer = setTimeout(() => {
                            window.scrollTo(0, Math.max(scrollHeight - 1, 0))
                            clearTimeout(timer)
                        })
                    }}
                    autoFocus={autoFocus}
                    onFocus={(e) => {
                        onFocus()
                        if (isAndroid()) {
                            // const target = e.target
                            let timer = setTimeout(() => {
                                ;(document.activeElement as any).scrollIntoViewIfNeeded()
                                // document.activeElement.scrollIntoViewIfNeeded() as any;
                                clearTimeout(timer)
                            })
                        }
                    }}
                    onChange={(e) => {
                        // e.target.scrollIntoView(true)
                        onChange(e.target.value as string)
                    }}
                    placeholder={placeholder}
                />
            )}
            {suffix && <div className='suffix'>{suffix}</div>}
            {after}
        </div>
    )
}

export default Input
